import { assets } from '../../styles/assets/assets';
import styles from './scss/orchestration.module.scss';
import { CircularProgressBar } from '../../components/custom_components/circularProgressBar';
import { useEffect, useState } from 'react';
import { orchestrationAgentGoals } from '../../apiservice/aiLycaPilot';
import { useNavigate } from 'react-router-dom';

const Orchestration = () => {
    const [loader, setLoader] = useState(false);
    const [goal, setGoal] = useState<any>(null);
    const [agentGoals, setAgentGoals] = useState<any>(null);

    useEffect(() => {
        const fetchNlpData = async () => {
            try {
                setLoader(true);
                const res = await orchestrationAgentGoals();
                if (res?.status === 200) {
                    const firstData = Object.keys(res.data.message) ?? null;
                    setGoal(res.data.message)
                    setAgentGoals(firstData);
                }
            } catch (error) {
                console.error("Error fetching NLP data:", error);
            } finally {
                setLoader(false);
            }
        };

        fetchNlpData();
    }, []);

    const navigate = useNavigate()
    const handleAgentGoalDetails = (data: any) => {
        console.log("handleAgentGoalDetails", data)
        navigate('/campaigns', { state: data })
    }

    return (
        <div className={styles.orchestrationsec}>
            <div className={styles.orchestleftsec}>
                <div className={styles.goalsec}>
                    <div className={styles.topheading}>
                        <h4>Agent Goal</h4>
                        <p className={styles.headerdesctxt}>What the agent is optimizing for.</p>
                    </div>
                    <div className={styles.goalrowmain}>
                        {agentGoals?.map((res: any, key: any) => (
                            <div className={styles.goalrow}>
                                <div key={key} className={styles.grcontent}>{res}</div>
                                <div className={`${styles.grstatus} ${styles.applreq}`}>Approval Required</div>
                                <div className={styles.rightchevron}><img onClick={() => handleAgentGoalDetails({ key: res, value: goal[res] })} src={assets.rightchevron} alt="rightchevron" /></div>
                            </div>
                        ))}
                    </div>
                    <div className={styles.viewstatus}>
                        <div className={styles.viewsts}>View hard guardrails</div>
                        <div className={styles.viewsts}>View soft guardrails</div>
                        <div className={styles.viewsts}>View policy (YAML)</div>
                    </div>
                </div>
                <div className={styles.liveupdates}>
                    <div className={styles.topheading}>
                        <h4>Live Updates</h4>
                        <p className={styles.headerdesctxt}>Micro-view of yesterday’s results by channel and overall.</p>
                    </div>
                    <div className={styles.liveblocksec}>
                        <div className={styles.liveblock}>
                            <div className={styles.topsec}>
                                <h4>Canary graduated; +1.9 pp</h4>
                                <p>5% canary (12h) was stable; cap increase graduated.</p>
                                <p>Reached ~18k users; +1.9 pp vs control.</p>
                                <p>Guardrails intact; no fatigue/fairness flags.</p>
                            </div>
                            <div className={styles.social}>
                                <div className={styles.socialinner}><img src={assets.email_icon} alt="email_icon" /> Email</div>
                                <div className={styles.socialinner}><img src={assets.whatsapp_icon} alt="whatsapp_icon" /> Whatsapp</div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className={styles.liveupdates}>
                    <div className={styles.topheading}>
                        <div className={styles.toplefts}>
                            <h2>Competitor Market Launches</h2>
                            <p className={styles.headerdesctxt}>Recent market moves highlight competitor growth strategies</p>
                        </div>
                    </div>
                    <div className={styles.liveblocksec}>
                        <div className={styles.liveblock}>
                            <div className={styles.topsec}>
                                <p>Canary graduated; +1.9 pp</p>
                                <span>5% canary (12h) was stable; cap increase graduated.</span>
                                <span>Reached ~18k users; +1.9 pp vs control.</span>
                                <span>Guardrails intact; no fatigue/fairness flags.</span>
                            </div>
                            <div className={styles.social}>
                                <p><img src={assets.email_icon} alt="email_icon" /> Email</p><p><img src={assets.whatsapp_icon} alt="whatsapp_icon" /> Whatsapp</p>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
            <div className={styles.orchestrightsec}>
                <div className={styles.topheading}>
                    <h4>Task Journey</h4>
                    <p className={styles.headerdesctxt}>Track task journey</p>
                </div>
                <div className={styles.taskblockmain}>
                    <div className={styles.taskblock}>
                        <div className={styles.taskheader}>Email</div>
                        <div className={styles.taskview}><img src={assets.email_icon} alt="email_icon" />Email</div>
                        <div className={styles.taskpara}>"Thanks for your purchase! You might also like these matching products. Thanks for your purchase! You might also like these matching products. Thanks for your purchase! You might also like these matching products. Thanks for your purchase! You might also like these matching products. Thanks for your purchase! You might also like these matching products."</div>
                        <div className={styles.timer}>Tomorrow, 9:00 AM</div>
                    </div>
                    <div className={styles.taskblock}>
                        <div className={styles.taskheader}>Email</div>
                        <div className={styles.taskview}><img src={assets.email_icon} alt="email_icon" />Email</div>
                        <div className={styles.taskpara}>"Thanks for your purchase! You might also like these matching products."</div>
                        <div className={styles.timer}>Tomorrow, 9:00 AM</div>
                    </div>
                    <div className={styles.taskblock}>
                        <div className={styles.taskheader}>Email</div>
                        <div className={styles.taskview}><img src={assets.email_icon} alt="email_icon" />Email</div>
                        <div className={styles.taskpara}>"Thanks for your purchase! You might also like these matching products."</div>
                        <div className={styles.timer}>Tomorrow, 9:00 AM</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Orchestration

